var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1786 18.9963L6.85044 21.3741C6.55079 21.5388 6.16503 21.4293 5.99153 21.0844C5.92183 20.9458 5.89698 20.785 5.92278 20.6278L6.74937 15.5914C6.8436 15.0173 6.66292 14.4262 6.25517 14.0108L2.75364 10.4441C2.48726 10.1727 2.4811 9.71665 2.74173 9.43723C2.84286 9.32882 2.97168 9.26189 3.10653 9.24142L7.94553 8.50662C8.52365 8.41883 9.01165 8.04149 9.26075 7.51406L11.4248 2.93181C11.5905 2.58102 11.9744 2.46203 12.2771 2.61815C12.4024 2.68279 12.5087 2.79144 12.575 2.93181L14.7391 7.51406C14.9882 8.04149 15.4762 8.41883 16.0543 8.50662L20.8933 9.24142C21.2283 9.29228 21.4992 9.63205 21.4427 10.0384C21.4207 10.1962 21.35 10.3383 21.2462 10.4441L17.7447 14.0108C17.3369 14.4262 17.1562 15.0173 17.2505 15.5914L18.0771 20.6278C18.1435 21.0324 17.8808 21.3804 17.5462 21.4404C17.412 21.4644 17.273 21.442 17.1494 21.3741L12.8213 18.9963C12.3079 18.7143 11.6919 18.7143 11.1786 18.9963Z",
    stroke: "#303C4A",
    strokeWidth: 1.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b5193b4f.svg";
export { ForwardRef as ReactComponent };